/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

 (function() {
  function getBarcodeMap() {
    const dataEl = document.getElementById('product-variant-barcodes');
    if (!dataEl) return {};
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return {};
    }
  }

  function updateEan(variantId, fallbackBarcode) {
    const eanElements = document.querySelectorAll('.product-ean-number');
    if (!eanElements.length) return;

    const barcodeMap = getBarcodeMap();
    // Liest den Barcode bevorzugt aus unserem eigenen JSON-Mapping
    const barcode = barcodeMap[variantId] || fallbackBarcode || '';

    eanElements.forEach(function(eanElement) {
      const wrapper = eanElement.closest('.product-ean-wrapper') || eanElement.parentElement;

      if (barcode && barcode.trim() !== '') {
        eanElement.textContent = barcode;
        if (wrapper) wrapper.style.display = '';
      } else {
        eanElement.textContent = '';
        if (wrapper) wrapper.style.display = 'none';
      }
    });
  }

  // 1. Theme-Event für Palo Alto
  document.addEventListener('theme:variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      updateEan(event.detail.variant.id, event.detail.variant.barcode);
    }
  });

  // 2. Fallback über URL/Formular-Änderungen
  document.addEventListener('change', function(event) {
    if (event.target.closest('form[action*="/cart/add"]')) {
      setTimeout(function() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
          updateEan(variantId);
        }
      }, 50);
    }
  });
})();




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
